module.exports = __webpack_public_path__ + "img/fish_yellowfish.195ee51e.png";